import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Industries from '../components/Industries';
import Fleet from '../components/Fleet';
import Testimonials from '../components/Testimonials';
import WhyChoose from '../components/WhyChoose';
import FAQ from '../components/FAQ';
import ContactCTA from '../components/ContactCTA';
import Footer from '../components/Footer';
import StickyMobileCTA from '../components/StickyMobileCTA';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Header />
      <main>
        <Hero />
        <Services />
        <Industries />
        <Fleet />
        <Testimonials />
        <WhyChoose />
        <FAQ />
        <ContactCTA />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
};

export default HomePage;
